/*
	Utils
*/

function updateObject(oldObject, newValues) {
	return Object.assign({}, oldObject, newValues);
}

function updateItemInArray(array, itemId, updateItemCallback) {
	const updatedItems = array.map(item => {
		if (item.project_id !== itemId) {
			return item;
		}
		const updatedItem = updateItemCallback(item);
		return updatedItem;
	});
	return updatedItems;
}

function createReducer(initialState, handlers) {
	return function(state = initialState, action) {
		if (handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](state, action);
		} else {
			return state;
		}
	};
}

function getProjectsSuccess(projectsState, action) {
	return action.result;
}

function saveProjectSuccess(projectsState, action) {
	// Update existing project
	if (action.oldProjectId) {
		return updateItemInArray(
			projectsState,
			action.oldProjectId,
			project => {
				delete action.result.project_id;
				return updateObject(project, action.result);
			}
		);
	}

	// Push new project
	const newProjects = projectsState.concat({
		...action.result
	});
	return newProjects;
}

function updateProjectState(projectsState, action) {
	return projectsState.map(project => {
		const isProject = project.project_id === action.projectId;
		if (isProject) {
			const newState = { state: 'matrix' };
			return updateObject(project, newState);
		}
		return project;
	});
}

const initialState = [];

function resetReducerToInitialState() {
	return initialState;
}

function deleteItemInArray(items, index) {
	return [...items.slice(0, index), ...items.slice(index + 1)];
}

const projectsReducer = createReducer(initialState, {
	GET_PROJECTS_SUCCESS: getProjectsSuccess,
	SAVE_PROJECT_SUCCESS: saveProjectSuccess,
	CLONE_PROJECT_SUCCESS: (state, action) => [...state, { ...action.result }],
	CLONE_PROJECT_TEMPLATE_SUCCESS: updateProjectState,
	DELETE_PROJECT_REQUEST: (state, action) => {
		const index = state.findIndex(
			project => project.project_id === action.projectId
		);

		return deleteItemInArray(state, index);
	},
	LOGOUT_SUCCESS: resetReducerToInitialState,
	'user/CLEAR': resetReducerToInitialState
});

function getProjectById(projectId, projects) {
	for (let i = 0; i < projects.length; i++) {
		if (projects[i].project_id === projectId) {
			return projects[i];
		}
	}
	/*return projects.find(project =>
		project.project_id === projectId
	);*/
}

export default projectsReducer;
export { getProjectById };



// WEBPACK FOOTER //
// ./src/js/project-v2/projectsReducer.js